export default __webpack_public_path__ + "static/apparel-mf-message-fabric-view-98730c1e2c081ab1655a2b6d210d644f.png";